import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-notas-contratos',
  templateUrl: './notas-contratos.component.html',
  styleUrls: ['./notas-contratos.component.scss']
})
export class NotasContratosComponent implements OnInit {

    public titulo;
    public info;

  constructor(@Inject(MAT_DIALOG_DATA) private datos) { }

  ngOnInit() {
      this.titulo = this.datos.title;
      this.info = this.datos.info;
  }

}
